import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import {
  fetchRejectedAllocator,
  fetchRejectedAllocatorFailed,
  fetchRejectedAllocatorSucceeded,
} from 'redux/slice/lenders/RejectedLenders.slice';
import { AllocatorListPayload } from 'redux/types/Allocator.types';

import { ApiStatusCodes } from '../../../services/api/apiStatusCode';
import { allocator } from '../../../services/api/endPoints';
import { HTTPClient } from '../../../services/api/http-client';
import { IFetchMyAllocatorResponse } from './Allocator.types';

export function* fetchRejectedAllocatorSaga({
  payload,
}: PayloadAction<AllocatorListPayload>) {
  try {
    const { agencyId } = payload;
    const result: IFetchMyAllocatorResponse = yield HTTPClient.GetRequest(
      allocator.GET_REJECTED_ALLOCATOR_LIST(agencyId)
    );

    const { data, status } = result;

    if (status === ApiStatusCodes.SUCCESS && data) {
      yield put(fetchRejectedAllocatorSucceeded(data?.allocatorList));
    } else {
      throw new Error();
    }
  } catch (error) {
    yield put(
      fetchRejectedAllocatorFailed({
        error: {
          message: 'An error occurred while fetching rejected lenders.',
        },
      })
    );
  }
}

export function* watchRejectedLenderSaga() {
  yield takeLatest(fetchRejectedAllocator.type, fetchRejectedAllocatorSaga);
}
